namespace Areas.Staff {
    "use strict";

    let vendorName: string;
    let vendorLicense: string = "";
    let vendorLicenseType: string = "";
    let searchType: string = 'Both';
    let runQuery: boolean = false;

    export function startVendorSearch() {
        runQuery = true;
        enableButton("ClearSearchButton");

        var grid = $('#VendorResultGrid').dxDataGrid("instance") as DevExpress.ui.dxDataGrid;
        grid.refresh();
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function getVendorName() {
        return vendorName;
    }

    export function getVendorLicense() {
        return vendorLicense;
    }

    export function getVendorLicenseType() {
        return vendorLicenseType;
    }

    export function getSearchType() {
        return searchType;
    }


    export function onVendorNameChanged(e) {
        vendorName = e.value;
    }

    export function onVendorLicenseChanged(e) {
        vendorLicense = e.value;
    }

    export function onVendorLicenseTypeChanged(e) {
        vendorLicenseType = e.value;
    }

    export function onContractorChanged(e) {
        searchType = e.value ? "Contractor" : "Both";
    }


    export function clearVendorSearch() {
        runQuery = false;
        searchType = "Both";

        disableButton("ClearSearchButton");

        var searchOptionsForm = $("#VendorSearchForm").dxForm("instance");
        var data = searchOptionsForm.option("formData");

        //update control values
        data.VendorLicenseToSearch = "";
        data.VendorNameToSearch = "";
        data.VendorLicenseTypeToSearch = "";
        data.ContractorOrDesignConsultantToSearch = false;

        searchOptionsForm.option("formData", data);

        var grid = $('#VendorResultGrid').dxDataGrid("instance") as DevExpress.ui.dxDataGrid;
        grid.refresh();
    }

    export function viewVendorLink(cellElement: any, cellInfo: any) {
        buildCellContent(cellElement,
            () => { return cellInfo.data.vendorId; },
            "<a href= '/Vendor/ViewPrint/Index/{placeholder}' target=\"_blank\">View</a>");
    }


}